// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3c7fb6a2","453":"3ee5950f","455":"7c4656d6","977":"973544d3"}[chunkId] + ".chunk.js";
};